import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { chapter18Lecture, chapter20Lecture } from '../ActivityVideo/ActivityArchitecture'
import { gitHubPages } from '../DataAndAPIs/Links'
import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'

import { learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, estimated, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'
import { architectureDesignLewisPhase1Link } from '../Activities/ArchitectureDesignLewis'
import { initialPost } from './AL00000Sprint00'

export const al61200Sprint05 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Successfully document software architecture</li>
			<li>Understand how to reconstruct the software architecture from existing products</li>
			<li>Describe Service-Oriented Architecture (SOA) and discuss its advantages</li>
			<li>Implement the client side of a service-oriented architecture</li>
		</ul>

		{list61200Sprint05(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint05 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, architectureDesignLewisPhase1Link(), oreillyPlaylistSA(), false)}
			<li>Create a {gitHubPages()} website that hosts your team’s {finalProjectProposalLink()}</li>
			<li>Read “Software Architecture in Practice (SAP) - Chapter 18: Documenting Software Architectures” and watch the associated {chapter18Lecture()}</li>
			{initialPost(sprint)}
			<li>Read “SAP - Chapter 20: Architecture Reconstruction and Conformance” and watch the associated {chapter20Lecture()}</li>
			{standardActivitiesClosing(sprint, architectureDesignLewisPhase1Link(), estimated('12 hours'))}
		</ol>
	</div> )
}
